import Api from './api.js'
import { accessorySystemType } from '../../../../../../common/constants.js'
import cachedRequest from '../../../../../../utils/cached-request'

export default {
  paasUpload: {
    state: {
      fileInfos: {},
      accessoryToken: '',
      previewParamKeyName: {
        fileReviewBusinessCode: '',
        bizCode: '',
        prewKey: ''
      }
    },
    methods: {
      getCheckInfo: {
        timeout: 240,
        handle: function (params) {
          const api = Api.paasCheckInfo
          return cachedRequest(api, params)
        }
      },
      getToken: {
        timeout: 240,
        handle: function () {
          const api = Api.getAccessoryToken
          return cachedRequest(api, {
            clientType: accessorySystemType
          })
        }
      },
      getPreviewParamName: {
        timeout: 240,
        handle: function (params) {
          const api = Api.getPreviewKeyName
          return cachedRequest(api, params)
        }
      }
    }
  }
}
